import { useMemo } from 'react';
import useUserProfile from './useUserProfile';

const useClipboard = () => {
  const { userProfile } = useUserProfile();

  const contactsWithDrafts = useMemo(() => {
    const store = JSON.parse(localStorage.getItem('chatRoomModule_clipboard')) || {};
    return Object.keys(store).map(x => x.replace(userProfile.id, ''));
  }, []);

  const getClipboard = () => JSON.parse(localStorage.getItem('chatRoomModule_clipboard')) || {};

  const updateClipboard = payload => {
    localStorage.setItem('chatRoomModule_clipboard', JSON.stringify(payload));
  };

  return { contactsWithDrafts, getClipboard, updateClipboard };
};

export default useClipboard;
